export default {
  // 苏宁
  operatingIncome: {
    label: '营业收入',
    placeholder: '请输入营业收入',
    type: 'AmountUnitInput',
    reg: null,
    msg: '',
    unit: '元',
    maxlength: 16
  },
  practitioners: {
    label: '从业人员',
    placeholder: '请输入从业人员',
    type: 'PeopleUnitInput',
    reg: null,
    msg: '',
    unit: '人',
    maxlength: 8
  },
  totalAssets: {
    label: '资产总额',
    placeholder: '请输入资产总额',
    type: 'AmountUnitInput',
    reg: null,
    msg: '',
    unit: '元',
    maxlength: 14
  },
  financeStaffName: {
    label: '财务联系人姓名',
    placeholder: '请输入财务联系人姓名',
    type: 'NameInput',
    labelWidth: '117px',
    reg: [
      {
        pattern: /^([\u4e00-\u9fa5]){2,10}$/,
        message: '只支持汉字,至少2个字符',
      },
    ],
    msg: ''
  },
  financeStaffPhone: {
    label: '财务联系人电话',
    placeholder: '请输入财务联系人电话',
    type: 'PhoneInput',
    labelWidth: '117px',
    reg: [{ pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号码' }],
    msg: '',
    maxlength: 11
  },

  orderId: {
    label: '订单ID',
    placeholder: '',
    type: 'BWInput',
    reg: null,
    msg: '',
  },
  productId: {
    label: '产品ID',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  loanAmount: {
    label: '借款金额',
    placeholder: '',
    type: 'RangeInput',
    reg: null,
    msg: '',
  },
  termLoan: {
    label: '借款期限',
    placeholder: '请选择借款期限',
    type: 'BWSelect',
    reg: null,
    msg: '',
  },
  loanIntendedUse: {
    label: '借款用途',
    placeholder: '请选择借款用途',
    type: 'BWSelect',
    reg: null,
    msg: '',
  },
  referrer: {
    label: '邀请码',
    placeholder: '请联系客户经理索要邀请码',
    type: 'Input',
    maxlength: 6,
    reg: [{ pattern: /^\d{6}$/, message: '请输入6位数字的邀请码' }],
    msg: '',
  },
  corpName: {
    label: '企业名称',
    placeholder: '请输入企业名称',
    type: 'Input',
    changeValue: true,
    msg: '',
    reg: null,
    readonly: true,
  },
  taxNo: {
    label: '企业税号',
    placeholder: '请输入统一社会信用代码',
    type: 'Input',
    changeValue: true,
    msg: '',
    reg: null,
    readonly: true,
  },
  borrowerType: {
    label: '申请人类型',
    placeholder: '请输入申请人类型',
    type: 'Input',
    changeValue: true,
    msg: '',
    reg: null,
    readonly: true,
  },
  bizProvince: {
    label: '企业所在省份',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  bizCity: {
    label: '企业所在城市',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  bizCounty: {
    label: '企业所在区县',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  bizAddress: {
    label: '详细地址',
    placeholder: '请输入详细地址至门牌号',
    type: 'Input',
    reg: [
      {
        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{6,}$/,
        message: '只支持汉字，字母和数字,至少6个字符',
      },
    ],
    msg: '',
  },
  bizAddressCode: {
    label: '企业所在区县行政区划代码',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  legalName: {
    label: '法人姓名',
    placeholder: '请输入法人姓名',
    type: 'Input',
    msg: '',
    readonly: true,
  },
  legalIdentity: {
    label: '身份证号',
    placeholder: '请输入身份证号码',
    type: 'Input',
    msg: '',
    readonly: true,
    reg: null,
  },
  legalPhone: {
    label: '法人手机号',
    placeholder: '请输入手机号码',
    type: 'Input',
    reg: [
      {
        pattern: /^1\d{10}$/,
        message: '请输入正确的手机号码',
      },
    ],
    msg: '',
    readonly: true,
  },
  borrowerName: {
    label: '姓名',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
    readonly: true,
  },
  borrowerIdentity: {
    label: '身份证号',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
    readonly: true,
  },
  borrowerPhone: {
    label: '手机号码',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
    readonly: true,
  },
  captcha: {
    label: '短信验证',
    placeholder: '请输入验证码',
    type: 'MessageCode',
    reg: [{ pattern: /^\d{6}$/, message: '验证码格式输入有误' }],
    msg: '',
  },
  borrowerEmail: {
    label: '电子邮箱',
    placeholder: '请输入电子邮箱',
    type: 'Input',
    reg: [
      {
        pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
        message: '请输入合法的电子邮箱',
      },
    ],
    msg: '',
  },
  borrowerLiveType: {
    label: '居住类型',
    placeholder: '请选择居住类型',
    type: 'BWSelect',
    reg: null,
    msg: '',
  },
  borrowerProvince: {
    label: '借款人企业所在省份',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  borrowerCity: {
    label: '借款人企业所在城市',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  borrowerCounty: {
    label: '借款人企业所在区县',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  borrowerAddress: {
    label: '详细地址',
    placeholder: '请输入详细地址至门牌号',
    type: 'Input',
    reg: [
      {
        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{6,}$/,
        message: '只支持汉字，字母和数字，至少6个字符',
      },
    ],
    msg: '',
  },
  borrowerAddressCode: {
    label: '借款人所在区县行政区划代码',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  bizPhone: {
    label: '办公电话',
    placeholder: '请输入办公电话',
    type: 'Input',
    reg: [{ pattern: /0\d{2,3}-\d{7,8}/, message: '请输入正确的办公电话' }],
    msg: '',
  },
  education: {
    label: '学历状况',
    placeholder: '请选择学历状况',
    type: 'BWSelect',
    reg: null,
    msg: '',
  },
  marriage: {
    label: '婚姻状况',
    placeholder: '请选择婚姻状况',
    type: 'BWSelect',
    reg: null,
    msg: '',
  },
  bankCard: {
    label: '银行卡号',
    placeholder: '请输入银行卡号',
    type: 'Input',
    // reg: [{ pattern: /[0-9]{19}/, message: "请输入正确的银行卡号" }],
    reg: [
      {
        pattern: /^\d{8,30}$/,
        message: '请输入正确的银行卡号',
      },
    ],
    maxlength: 30,
    msg: '',
  },
  creditBankCard: {
    label: '信用卡号',
    placeholder: '请输入信用卡号',
    type: 'Input',
    // reg: [{ pattern: /[0-9]{19}/, message: "请输入正确的信用卡号" }],
    reg: [
      {
        pattern: /^([1-9]{1})(\d{15}|\d{16}|\d{17}|\d{18})$/,
        message: '请输入正确的信用卡号',
      },
    ],
    msg: '',
  },
  creditAccount: {
    label: '人行验证用户名',
    placeholder: '请输入人行验证用户',
    type: 'Input',
    reg: [{ pattern: /[0-9]{19}/, message: '请输入正确的人行验证用户名' }],
    msg: '',
  },
  creditPassword: {
    label: '人行验证密码',
    placeholder: '请输入人行验证密码',
    type: 'Input',
    reg: [{ pattern: /[0-9]{19}/, message: '请输入正确的人行验证密码' }],
    msg: '',
  },
  creditCaptcha: {
    label: '人行验证验证码',
    placeholder: '请输入人行验证验证码',
    type: 'Input',
    reg: [{ pattern: /[0-9]{19}/, message: '请输入正确的人行验证验证码' }],
    msg: '',
  },
  corpAuthContract: {
    label: '企业授权合同',
    placeholder: '',
    type: 'Input',
    reg: null,
    msg: '',
  },
  // emergencyContact: {
  //     label: "紧急联系人",
  //     placeholder: "",
  //     type: "Input",
  //     reg: null,
  //     msg: ""
  // },
  relationshipWith: {
    label: '紧急联系人',
    placeholder: '请选择紧急联系人关系',
    type: 'BWSelect',
    reg: null,
    msg: '',
  },
  iceContactName: {
    label: '姓名',
    placeholder: '请输入紧急联系人姓名',
    type: 'Input',
    reg: [
      {
        pattern: /^([\u4e00-\u9fa5]){2,10}$/,
        message: '只支持汉字,至少2个字符',
      },
    ],
    maxlength: 10,
    msg: '',
  },
  relationMobilePhone: {
    label: '手机号码',
    placeholder: '请输入直系亲属联系人电话',
    type: 'Input',
    maxlength: 11,
    reg: [{ pattern: /^1\d{10}$/, message: '请输入正确的手机号码' }],
    msg: '',
  },
  relationName: {
    label: '亲属姓名',
    placeholder: '请输入直系亲属联系人姓名',
    type: 'Input',
    reg: [
      {
        pattern: /^([\u4e00-\u9fa5]){2,10}$/,
        message: '请输入正确的直系亲属联系人姓名',
      },
    ],
    maxlength: 10,
    msg: '',
  },
  iceContactIdentity: {
    label: '身份证号',
    placeholder: '请输入紧急联系人身份证号码',
    type: 'Input',
    toUpperCase: true,
    reg: [
      {
        pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        message: '请输入正确的证件号码',
      },
    ],
    maxlength: 18,
    msg: '',
  },
  iceContactPhone: {
    label: '手机号码',
    placeholder: '请输入紧急联系人手机号码',
    type: 'Input',
    maxlength: 11,
    reg: [{ pattern: /^1\d{10}$/, message: '请输入正确的手机号码' }],
    msg: '',
  },
  RelatedSelect: {
    label1: '婚姻状况',
    label2: '紧急联系人',
    placeholder: '请选择紧急联系人关系',
    type: 'RelatedSelect',
    reg: null,
    msg: '',
  },
  LocatedPlacePicker: {
    label: '经营地址',
    placeholder: '请选择实际经营所在地区',
    type: 'LocatedPlacePicker',
    reg: null,
    msg: '',
  },
  LivingPlacePicker: {
    label: '居住地区',
    placeholder: '请选择居住地区',
    type: 'LivingPlacePicker',
    reg: null,
    msg: '',
  },
  contract: {
    reg: null,
  },
};
